import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { FETCH_CALL_STATUS_SUCCESS } from "../actions/callStatusActions";

const intitialState = {
  entities: null,
  aggregate: null,
};
const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-callStatus";
};

export const callStatusReducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: ["entities", "aggregate"],
  },
  (state = intitialState, action) => {
    switch (action.type) {
      case FETCH_CALL_STATUS_SUCCESS: {
        if (action.payload && action.payload.status === 200) {
          var newState = {
            ...state,
            entities: action.payload.success.call_connectivity,
            aggregate: action.payload.success.aggregate,
          };
        }
        return newState;
      }
      case actionTypes.Logout: {
        return intitialState;
      }
      default: {
        return state;
      }
    }
  }
);
